import React, { useState, useEffect } from "react";
import { HoursOverview } from "./components/overview";
import { ByProjectTypeDepartment } from "./components/by-project-type";
import { useProjectEmployeeTimesheet } from "./api/clientProject";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import { ProjectTypeBarChart } from "./components/project-type-barchart";
import { selectUser } from "store/src/slices/auth-slice";
import { useSelector } from "react-redux";
import { useDepartmentOverview } from "./api/departmentoverview";
import { TeamUtilizationStackedChart } from "./components/team-utilization-chart";
import HeaderPortal from "components/portal/header-portal";
import TimesheetDepartmentOverviewFilters from "./filters";


export default function TimesheetDepartmentOverview() {
  const { department } = useSelector(selectUser);

  const [filters, setFilters] = useState({
    startDate: CURRENT_MONTH_START_DATE,
    endDate: CURRENT_MONTH_END_DATE,
    departmentId: department?.id,
  });

  useEffect(() => {
    if (department?.id && !filters.departmentId) {
      setFilters((prev) => ({
        ...prev,
        departmentId: department.id,
      }));
    }
  }, [department, filters.departmentId]);


  const {
    data: data,
    isLoading,
    error,
  } = useDepartmentOverview({
    departmentId: filters?.departmentId,
    startDate: filters?.startDate,
    endDate: filters?.endDate,
  });

  const {
    data: clientProjectData,
    isClientLoading,
    clientError,
  } = useProjectEmployeeTimesheet({
    departmentId: filters?.departmentId,
    startDate: filters?.startDate,
    endDate: filters?.endDate,
    type: "client",
  });

  const {
    data: internalProjectData,
    isInternalLoading,
    internalError,
  } = useProjectEmployeeTimesheet({
    departmentId: filters?.departmentId,
    startDate: filters?.startDate,
    endDate: filters?.endDate,
    type: "internal",
  });

  const {
    data: presalesProjectData,
    isPresalesLoading,
    presalesError,
  } = useProjectEmployeeTimesheet({
    departmentId: filters?.departmentId,
    startDate: filters?.startDate,
    endDate: filters?.endDate,
    type: "pre_sales",
  });

  return (
    <div className="flex-1">
      <HeaderPortal>
        <TimesheetDepartmentOverviewFilters
          filters={filters}
          setFilters={setFilters}
        />
      </HeaderPortal>
      <HoursOverview data={data} isLoading={isLoading} error={error} />
      <ByProjectTypeDepartment
        filters={filters}
      />
      <TeamUtilizationStackedChart
        data={data}
        isLoading={isLoading}
        error={error}
        title="Team Utilization"
      />
      <ProjectTypeBarChart
        data={clientProjectData}
        isLoading={isClientLoading}
        error={clientError}
        filters={filters}
        title="Client Projects"
      />
      <ProjectTypeBarChart
        data={internalProjectData}
        isLoading={isInternalLoading}
        error={internalError}
        filters={filters}
        title="Internal Projects"
      />
      <ProjectTypeBarChart
        data={presalesProjectData}
        isLoading={isPresalesLoading}
        error={presalesError}
        filters={filters}
        title="Pre-Sales Projects"
      />
    </div>
  );
}

